import { useAppContext } from 'business/contextProviders/useAppContext';
import ReportCreatePage from 'business/shift-report/report/pages/ReportCreate';
import ReportListPage from 'business/shift-report/report/pages/ReportList';
import { useMediaType } from 'technical/media/hooks';

const ShiftReportHome = () => {
  const { currentConstructionSite } = useAppContext();
  const { isMobile } = useMediaType();

  return isMobile || currentConstructionSite?.isCompleted ? (
    <ReportListPage />
  ) : (
    <ReportCreatePage />
  );
};

export default ShiftReportHome;
